import Store, { actions } from '@store';
import { AdvancedOrderedListChainHandler } from 'src/factories/advanced-ordered-list/chain-handler';
import { getElementsContainOrderedList, getElementsToAdd, getElementsToDelete, getPreviousElementInChain } from '../prepares/elements.prepare';
import { setElementsFromPage } from '../actions/page.action';

function configureDispatchers ({ EditorFacade }) {
  EditorFacade.on('history.change', () =>
    updateOrderedListChains(INKIVE.PageFactory.getCurrentPageId())
  );
  EditorFacade.on('history.undo', () =>
    updateOrderedListChains(INKIVE.PageFactory.getCurrentPageId())
  );
  EditorFacade.on('history.redo', () =>
    updateOrderedListChains(INKIVE.PageFactory.getCurrentPageId())
  );
}

async function updateElementsFromCurrentPage () {
  const id = INKIVE.PageFactory.getCurrentPageId();
  const content = INKIVE.EditorFacade.editor.getSvgString();
  const skipAddToTextMock = true;

  Store.dispatch(setElementsFromPage({ id, content, skipAddToTextMock }));
}

async function updateOrderedListChains (pageId) {
  if (!Store.getState()?.metadata?.bullet_and_ordered_list) return;

  updateElementsFromCurrentPage();
  const newPageChains = getElementsContainOrderedList(pageId);
  const oldPageChains = new AdvancedOrderedListChainHandler().extractChainOnPage(pageId);
  const elementsToDelete = getElementsToDelete(newPageChains, oldPageChains);

  const elementsToAdd = getElementsToAdd(newPageChains, oldPageChains);
  removeFromOrderedListChain(elementsToDelete);

  const previousElementInChain = getPreviousElementInChain(elementsToAdd, pageId);
  addToOrderedListChain(elementsToAdd, previousElementInChain, pageId);

  const hasOrderedListInPage = document.querySelector('#svgcontent [data-ordered-style]');
  if (hasOrderedListInPage) {
    INKIVE.AdvancedOrderedListFactory.updateTextsInPage(pageId);
  }
}

function removeFromOrderedListChain (elementsToRemove) {
  if (!elementsToRemove) return;

  for (const chainId in elementsToRemove) {
    Store.dispatch(actions.metadata.removeFromOrderedListChain({
      elements: elementsToRemove[chainId],
      chainId
    }));
  }
}

function addToOrderedListChain (elementsToAdd, previousElementInChain, pageId) {
  if (!elementsToAdd) return;

  const chains = INKIVE.AdvancedOrderedListFactory.findChainByPageId(pageId) || {};
  for (const chainId in elementsToAdd) {
    const nextTo = chains[chainId]
      ? null
      : previousElementInChain[chainId];

    Store.dispatch(actions.metadata.addToOrderedListChain({
      elements: elementsToAdd[chainId],
      chainId,
      nextTo
    }));
  }
}

export default {
  configureDispatchers
};
